if(!customElements.get('stepped-columns')) {
  class SteppedColumns extends HTMLElement {
    constructor() {
      super();

      this.elHeader = this.querySelector('[data-header]');
      this.elSteps = this.querySelectorAll('[data-step]');

      this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    }

    connectedCallback() {
      document.addEventListener('readystatechange', () => {
        if (document.readyState === "complete") {
          gsap.registerPlugin(ScrollTrigger);
          this.setRowHeights();
          window.addEventListener('resize', () => {
            let isDesktop = window.matchMedia('(min-width: 1024px)').matches;
            isDesktop !== this.isDesktop && (this.desktop = isDesktop);
            this.setRowHeights.bind(this);
          })

          // this.controller = new ScrollMagic.Controller();
          // this.scene = new ScrollMagic.Scene({triggerElement: this.parentNode, duration: '100%' })
          //   .setPin(this.elHeader, true)
					// 	.addIndicators({ name: "1 (duration: 100%)" })
					// 	.addTo(this.controller);

          // // // this.scene.setPin(this.elHeader, true);
          // // // this.elSteps.forEach(el => this.scene.setPin(el, true));

          // this.elSteps.forEach((el, index) => {
          //   const elText = el.querySelector('[data-step-text]');
          //   const scene = new ScrollMagic.Scene({ triggerElement: el, duration: '100%' })
          //   scene.setPin(elText);
          //   scene.addIndicators({ name: `${index} (duration: 100%)` })
          //   scene.addTo(this.controller);
          // })
        }
      })
    }

    setRowHeights() {
      const itemsPerRow = this.isDesktop ? 3 : 2;
      const totalRows = this.elSteps.length / itemsPerRow;
      const rowGap = this.isDesktop ? 72 : 16;

      // const rowHeights = {};
      // this.elSteps.forEach((el, i) => {
      //   let stepRowIndex = Math.ceil((i + 1) / itemsPerRow);
      //   let height = el.querySelector('[data-step-text]').clientHeight;
      //   if(rowHeights[stepRowIndex]) {
      //     rowHeights[stepRowIndex] < height && (rowHeights[stepRowIndex] = height);
      //   } else {
      //     rowHeights[stepRowIndex] = height 
      //   }
      // });
      
      // this.elSteps.forEach((el, index) => {
      //   const rowIndex = Math.ceil((index + 1) / itemsPerRow);
      //   const columnIndex = index % itemsPerRow + 1;
        
      //   const isFistRow = rowIndex == 0;
      //   const isLastRow = rowIndex == totalRows;

      //   const start = isFistRow ? 0 : rowHeights[rowIndex + 1];

      //   el.style.height = `${rowHeights[rowIndex]}px`;

      //   // const prevRowHeights = elPrevRows.map(el => el.querySelector('[data-step-text]').clientHeight);
      //   // console.log(prevRowHeights);

      //   let tl = gsap.timeline({
      //     // yes, we can add it to an entire timeline!
      //     scrollTrigger: {
      //       trigger: el,
      //       pin: true, // pin the trigger element while active
      //       start: start, // when the top of the trigger hits the top of the viewport
      //       end: '+=500', // end after scrolling 500px beyond the start
      //       scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      //       snap: {
      //         snapTo: 'labels', // snap to the closest label in the timeline
      //         duration: { min: 0.2, max: 3 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
      //         delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
      //         ease: 'power1.inOut' // the ease of the snap animation ("power3" by default)
      //       }
      //     }
      //   })
      // })

      // this.elSteps.forEach((el, index) => {
      //   const rowIndex = Math.ceil((index + 1) / itemsPerRow);
      //   const columnIndex = index % itemsPerRow + 1;

      //   const elOtherColumnsInRow = [...this.elSteps].filter((e, i) => Math.ceil((i + 1) / itemsPerRow) == rowIndex);
      //   // const elPrevRowSteps = [...this.elSteps].filter((e, i) => Math.ceil((i + 1) / itemsPerRow) < rowIndex);
      //   // const elNextRowSteps = [...this.elSteps].filter((e, i) => Math.ceil((i + 1) / itemsPerRow) > rowIndex);
        
      //   // console.log(elPrevRows, elNextRows);


      //   const elPrevRowsInColumn = [...this.elSteps].filter((e, i) => (i % itemsPerRow + 1 == columnIndex) && i < index);
      //   const elNextRowsInColumn = [...this.elSteps].filter((e, i) => (i % itemsPerRow + 1 == columnIndex) && i > index);

      //   const rowColumnsHeights = elOtherColumnsInRow.map(el => el.querySelector('[data-step-text]').clientHeight);
      //   const prevRowsSize = elPrevRowsInColumn.map(el => el.querySelector('[data-step-text]').clientHeight + rowGap);
      //   const nextRowsSize = elNextRowsInColumn.map(el => el.querySelector('[data-step-text]').clientHeight + rowGap);
      //   console.log(el, nextRowsSize)

      //   const largestColumnHeight = rowColumnsHeights.sort((a,b)=>a-b).reverse()[0];
      //   const totalTopPadding = prevRowsSize.reduce((partialSum, a) => partialSum + a, 0);
      //   const totalBottomPadding = nextRowsSize.reduce((partialSum, a) => partialSum + a, 0);

      //   el.style.setProperty('--height', `${largestColumnHeight}px`);
      //   el.style.setProperty('--top-padding', `${totalTopPadding + rowGap}px`);
      //   el.style.setProperty('--bottom-padding', `${totalBottomPadding + rowGap}px`);
      // })
    }

    // setHeights() {
    //   const itemsPerRow = this.isDesktop ? 3 : 2;
    //   const totalRows = this.elSteps.length / itemsPerRow;
    //   const rowGap = this.isDesktop ? 72 : 16;

    //   let headerPaddingBottom = 0;

    //   this.style.setProperty('--stepped-header-height', `${this.elHeader ? this.elHeader.clientHeight + rowGap : 0}px`);

    //   this.elSteps.forEach((el, index) => {

    //     const rowIndex = Math.ceil((index + 1) / itemsPerRow);
    //     const columnIndex = index % itemsPerRow + 1;
    //     const isEven = (index + 1) % 2 == 0;

    //     const isFirstRow = rowIndex == 1;
    //     const isLastRow = rowIndex == totalRows;
        
    //     const elStepsInRow = [...this.elSteps].filter((e, i) => (Math.ceil((i + 1) / itemsPerRow) == rowIndex));
    //     const rowStepHeights = elStepsInRow.map(el => el.querySelector('[data-step-inner]').clientHeight);
    //     const largestRowStepHeight = rowStepHeights.sort((a,b)=>a-b)[rowStepHeights.length - 1];

    //     console.log(el, elStepsInRow, rowStepHeights, largestRowStepHeight)

    //     const gap = isLastRow ? 0 : rowGap;
    //     const height = largestRowStepHeight + gap;
    //     const topPadding = this.isDesktop ? 0 : isEven ? el.clientHeight / 2 : 0;
        
    //     let top = 0;

    //     el.classList.toggle('last-row', isLastRow);
    //     el.style.setProperty('--step-height', `${height}px`);
    //     el.style.setProperty('--step-padding-top', `${topPadding}px`);

    //     if(!isLastRow) {
    //       const elOtherStepsInColumn = [...this.elSteps].filter((e, i) => ((i % itemsPerRow + 1) == columnIndex) && i > index );
    //       const otherStepHeights = elOtherStepsInColumn.map(e => e.querySelector('[data-step-inner]').clientHeight + gap);
    //       const totalOtherHeights = otherStepHeights.reduce((partialSum, a) => partialSum + a, 0);
    //       el.style.setProperty('--step-padding-bottom', `${totalOtherHeights}px`);
    //     }

    //     if(!isFirstRow) {
    //       const elPrevStep = this.elSteps[index - itemsPerRow];
    //       top = elPrevStep.style.getPropertyValue('--step-top');
    //       el.style.setProperty('--step-top', `calc(${elPrevStep.style.getPropertyValue('--step-top')} + ${elPrevStep.style.getPropertyValue('--step-height')})`);
    //     } else {
    //       top = this.elHeader.clientHeight;
    //       el.style.setProperty('--step-top', 'var(--stepped-header-height)');
    //     }
    //   })

    //   this.style.setProperty('--stepped-header-padding-bottom', `${headerPaddingBottom}px`);
    // }
  }

  customElements.define('stepped-columns', SteppedColumns);
}